import React, { useEffect, useState } from "react";
import { Layout, Row, Menu, Popover, Avatar } from "antd";
import { BankOutlined } from "@ant-design/icons";
import { footerText } from "util/config";
import { useSelector, useDispatch } from "react-redux";
import { Link, Route, Switch } from "react-router-dom";
import {
  NAV_STYLE_DRAWER,
  NAV_STYLE_FIXED,
  NAV_STYLE_MINI_SIDEBAR,
  NAV_STYLE_NO_HEADER_MINI_SIDEBAR,
  TAB_SIZE,
  THEME_TYPE_LITE,
} from "../constants/ThemeSetting";
import {
  toggleCollapsedSideNav,
  onNavStyleChange,
} from "appRedux/actions/Setting";
import CustomScrollbars from "util/CustomScrollbars";
import { useRouteMatch } from "react-router-dom";
import RequestHandler from "../util/RequestHandler";
import FirmTrackingListByFirm from "./FirmTracking/FirmTrackingListByFirm";
import FirmTrackingTransactionDetail from "./FirmTracking/FirmTrackingTransactionDetail";
import FirmTrackingTransactionDetailPayAndRevenue from "./FirmTracking/FirmTrackingTransactionDetailPayAndRevenue";

const { Content, Footer, Header, Sider } = Layout;

const FirmTrackingApp = (props) => {
  //console.log("COMPONENT GÖNDERİMİ SAYFASI", props.match.params);
  const dispatch = useDispatch();
  const match = useRouteMatch();
  const { themeType, navCollapsed, width, navStyle, pathname } = useSelector(
    ({ settings }) => settings
  );
  const [firmName, setFirmName] = useState("");
  const [firmId, setFirmId] = useState(props.match.params.firmId);
  const [transactionId, setTransactionId] = useState(
    props.match.params.transactionId
  );
  const [planId, setplanId] = useState(props.match.params.planId);
  const [isFirmFound, setIsFirmFound] = useState(false);
  const [currencyCode, setCurrencyCode] = useState(
    props.match.params.currencyCode
  );
  const [componentControl, setComponentControl] = useState("");
  const [MonthlyPlanId, setMonthlyPlanId] = useState("");
  const [newPageMonthlyId, setNewPageMonthlyId] = useState("");
  const [clickedButton, setClickedButton] = useState(false);

  const selectedKeys = pathname.substr(1);
  const defaultOpenKeys = selectedKeys.split("/")[1];

  useEffect(() => {
    RequestHandler.get(
      `/FirmTracking/GetFirmById/${props.match.params.firmId}`,
      undefined,
      {
        rawResponse: true,
      }
    ).then((response) => {
      if (response.status == 200) {
        setFirmName(response.data.name);
        setIsFirmFound(true);
      }
    });
  }, []);

  useEffect(() => {
    if (
      props.match.params.transactionId ===
      "00000000-0000-0000-0000-000000000000"
    ) {
      RequestHandler.get(
        `/FirmTracking/GetById/${props.match.params.planId}`
      ).then((res) => {
        var monthlyId = res.id;
        setNewPageMonthlyId(monthlyId);

        var tpType = res.otherTransactionProcessType;
        if (tpType === 1 || tpType === 2) {
          setComponentControl(false);
        } else {
          setComponentControl(true);
        }
      });
    } else if (
      props.match.params.planId === "00000000-0000-0000-0000-000000000000"
    ) {
      RequestHandler.get(
        `/FirmTracking/TransactionGetById/${props.match.params.transactionId}`
      ).then((res) => {
        var tpType = res.transactionProcessType;

        if (tpType === 1 || tpType === 2) {
          setComponentControl(false);
        } else {
          setComponentControl(true);
        }
      });
    }
  }, []);

  const handleDetailClick = (
    eArchiveId,
    eInvoiceId,
    processTypeName,
    id,
    clickedButton
  ) => {
    //console.log("eArchiveId", eArchiveId);
    //console.log("eInvoiceId", eInvoiceId);
    setMonthlyPlanId(id);
    setClickedButton(clickedButton);

    let componentControl = true;
    if (
      (processTypeName === "Satış Faturası" ||
        processTypeName === "Alış Faturası") &&
      eInvoiceId === null &&
      eArchiveId === null
    ) {
      componentControl = false;
    } else if (processTypeName === "Tahsilat" || processTypeName === "Ödeme") {
      componentControl = false;
    }

    setComponentControl(componentControl);
  };

  //console.log("clikbuton", clickedButton);

  return (
    <Layout className="full-layout">
      <Sider
        style={{ backgroundColor: "#0047ca" }}
        className={`ant-layout-sider-dark gx-app-sidebar  gx-layout-sider-dark`}
        trigger={null}
        collapsed={
          width < TAB_SIZE
            ? false
            : navStyle === NAV_STYLE_MINI_SIDEBAR ||
              navStyle === NAV_STYLE_NO_HEADER_MINI_SIDEBAR
        }
        theme="dark"
        collapsible
      >
        <div style={{ color: "white" }}>
          <div className="gx-layout-sider-header gx-layout-sider-dark'">
            <div className="gx-linebar">
              <i
                className={`gx-icon-btn icon icon-${
                  navStyle === NAV_STYLE_MINI_SIDEBAR
                    ? "menu-unfold"
                    : "menu-fold"
                } ${themeType !== THEME_TYPE_LITE ? "gx-text-white" : ""}`}
                onClick={() => {
                  if (navStyle === NAV_STYLE_DRAWER) {
                    dispatch(toggleCollapsedSideNav(!navCollapsed));
                  } else if (navStyle === NAV_STYLE_FIXED) {
                    dispatch(onNavStyleChange(NAV_STYLE_MINI_SIDEBAR));
                  } else if (navStyle === NAV_STYLE_NO_HEADER_MINI_SIDEBAR) {
                    dispatch(toggleCollapsedSideNav(!navCollapsed));
                  } else {
                    dispatch(onNavStyleChange(NAV_STYLE_FIXED));
                  }
                }}
              />
            </div>

           
          </div>

          <div className="gx-sidebar-content" style={{ color: "white" }}>
            <div
              className={`gx-sidebar-notifications gx-no-header-notifications";
            }`}
              style={{ borderBottomColor: "white" }}
            >
              <div className="gx-flex-row gx-align-items-center gx-mb-4 gx-avatar-row">
                <Popover placement="bottomRight" trigger={"ten clikckasdad"}>
                  <Avatar
                    style={{ backgroundColor: "#002447" }}
                    icon={<BankOutlined />}
                    className="gx-size-40 gx-pointer gx-mr-3"
                    alt=""
                  />
                  <span className="gx-avatar-name">
                    {firmName}
                    <i className="icon icon-chevron-down gx-fs-xxs gx-ml-2" />
                  </span>
                </Popover>
              </div>
            </div>
            <CustomScrollbars className="gx-layout-sider-scrollbar">
              <Menu
                defaultOpenKeys={[defaultOpenKeys]}
                selectedKeys={[selectedKeys]}
                theme="dark"
                mode="inline"
              >
                <Menu.Item key="0">
                  <Link
                    style={{ color: "white" }}
                    to={`/firm-tracking/${firmId}/null/null/${currencyCode}`}
                  >
                    <i className="icon icon-calendar" />
                    <span>Tüm İşlemler</span>
                  </Link>
                </Menu.Item>
              </Menu>
            </CustomScrollbars>
          </div>
        </div>
      </Sider>
      <Layout>
        <Header></Header>

        <Content className={`ant-layout-content gx-layout-content`}>
          {props.match.params.transactionId == "null" &&
          props.match.params.planId == "null" ? (
            <div className="gx-main-content-wrapper">
              <FirmTrackingListByFirm
                firmId={props.match.params.firmId}
                currency={props.match.params.currencyCode}
                onDetailClick={handleDetailClick}
              />
            </div>
          ) : componentControl ? (
            <div className="gx-main-content-wrapper">
              <FirmTrackingTransactionDetail
                transactionId={props.match.params.transactionId}
                planId={props.match.params.planId}
                MonthlyPlanId={MonthlyPlanId}
                newPageMonthlyId={newPageMonthlyId}
                clickedButton={clickedButton}
              />
            </div>
          ) : (
            <div className="gx-main-content-wrapper">
              <FirmTrackingTransactionDetailPayAndRevenue
                transactionId={props.match.params.transactionId}
                planId={props.match.params.planId}
              />
            </div>
          )}

          <Footer>
            <Row justify="space-between" align="middle">
            <div className="gx-layout-footer-content">{footerText}</div>
            </Row>
          </Footer>
        </Content>
      </Layout>
    </Layout>
  );
};
export default FirmTrackingApp;
